import React from 'react';
import { string, shape } from 'prop-types';
var AllIn = function AllIn(_ref) {
  var url = _ref["static"].url;
  return React.createElement("script", {
    defer: true,
    fetchpriority: "low",
    src: url
  });
};
AllIn.ssr = true;
process.env.NODE_ENV !== "production" ? AllIn.propTypes = {
  "static": shape({
    url: string
  })
} : void 0;
AllIn.defaultProps = {
  "static": {
    url: 'https://i.btg360.com.br/btg360-2.0.1.min.js'
  }
};
export default AllIn;